import type { Action } from 'redux';

export function createReducers<State, ActionTypes extends Action>(
    initialState: State,
    reducers: ReducersType<ActionTypes, State>
) {
    return (state = initialState, action: ActionTypes) => {
        const currentReducer = (reducers as any)[action.type];

        return currentReducer ? currentReducer(state, action) : state;
    };
}

type ReducersType<ActionTypes extends Action, State = {}> = {
    [key in ActionTypes['type']]: (state: State, action: Extract<ActionTypes, { type: key }>) => State | void;
};
